(function () {
  function siteHeaderOffsetPx() {
    var custom = document.querySelector('.custom-header');
    if (!custom) return 0;
    var h = custom.getBoundingClientRect().height;
    return h > 0 ? Math.round(h) : 0;
  }

  function applySiteHeaderOffset(root) {
    var px = siteHeaderOffsetPx();
    root.style.setProperty('--careers-site-header-offset', px ? px + 'px' : '0px');
  }

  function initCareersPage(root) {
    if (!root || root.dataset.careersPageInit === 'true') return;
    root.dataset.careersPageInit = 'true';

    applySiteHeaderOffset(root);
    window.addEventListener(
      'resize',
      function () {
        applySiteHeaderOffset(root);
      },
      { passive: true }
    );

    var buttons = Array.prototype.slice.call(root.querySelectorAll('.role-filter'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.role-card'));
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var filter = button.dataset.filter;
        buttons.forEach(function (btn) {
          btn.setAttribute('aria-pressed', String(btn === button));
        });
        cards.forEach(function (card) {
          card.hidden = filter !== 'all' && card.dataset.category !== filter;
        });
      });
    });

    var copyButton = root.querySelector('.copy-email');
    var toast = root.querySelector('.toast');
    if (copyButton && toast) {
      copyButton.addEventListener('click', function () {
        var email = copyButton.dataset.email;
        if (!email) return;

        function showToast() {
          toast.classList.add('show');
          window.setTimeout(function () {
            toast.classList.remove('show');
          }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(email).then(showToast).catch(function () {
            fallbackCopy(email);
            showToast();
          });
          return;
        }

        fallbackCopy(email);
        showToast();
      });
    }
  }

  function fallbackCopy(text) {
    var input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'absolute';
    input.style.left = '-9999px';
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  }

  function boot() {
    document.querySelectorAll('[data-careers-page]').forEach(initCareersPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
